export default {
  'status': 'Translation validated by country',
  'meta': {
    'lang': 'Magyar'
  },
  'title': 'GYORS HÍREK SIMOND ALPINISM / VERTIKA TERMÉKVISSZAHÍVÁS',
  'homepage': {
    'notice': 'Termékvisszahívás. Fontos információk a biztonságával és a felszerelésével kapcsolatban.',
    'purchaseWindow': 'Ön ALPINISM és/vagy VERTIKA mászó gyorskötőt vásárolt 2022. január 1. és 2026. július 23. között.',
    'skus': 'Alpinism 11 cm-es gyorskötő (4051175 / 8589547)\nAlpinism 17 cm-es gyorskötő (4051176 / 8589548)\n5 db-os Alpinism gyorskötő csomag (4171656 / 8608405)\nVertika 11 cm-es gyorskötő (5499689 / 8935765)\nVertika 17 cm-es gyorskötő (5500194 / 8935909)',
    'responsibility': 'A személyi védőfelszerelések tervezése teljes felelősséggel jár azok iránt, akik termékeinket használják. Ezért tájékoztatjuk Önt a Rocky Fil karabinerrel felszerelt gyorskötő visszahívásáról.',
    'defect': 'Egyes karabinereken hibát észleltünk a drótkapu szegecselésében. Ez az összeszerelési hiba a drótkapu törését okozhatja, és esés esetén fennáll a karabiner törésének veszélye.',
    'stopUsing': 'Elővigyázatosságból kérjük, hogy azonnal hagyja abba a termék használatát, és kövesse az alábbi eljárást.'
  },
  'procedure': {
    'stopUsing': 'Ezért kérjük, hogy azonnal hagyja abba a berendezés használatát, és az alábbi hibaelhárítási utasítások segítségével ellenőrizze, hogy a termékén fennáll-e a hiba.',
    'title': 'A termék ellenőrzése:',
    'intro': 'Ellenőrizze, hogy a drótkapu mindkét oldala biztonságosan rögzítve van-e a karabinerhez:',
    'step1': 'Fogja meg a karabinert az egyik oldalon, helyezze a hüvelykujját a két drót közé (a szegecshez legközelebb eső hüvelykujj). Nyomja erősen lefelé a karabinerhez.',
    'step2': 'Fordítsa meg a karabinert, és ismételje meg ugyanezt a műveletet a drótkapu másik oldalán.'
  },
  'outcome': {
    'nok': {
      'body': 'Az ellenőrzést követően a drót meglazult: Kérjük, azonnal hagyja abba a termék használatát, és vigye vissza a legközelebbi DECATHLON áruházba. Csapatunk gondoskodik a hibás termékről, és azonnal visszatéríti a visszahívott termékek árát.',
      'support': 'Ha bármilyen nehézséget tapasztal, ügyfélszolgálati csapatunk készséggel áll rendelkezésére, hogy személyre szabott megoldást találjon, és végigvezesse Önt a folyamaton: [A dátumokat és időpontokat ide kell beírni].'
    },
    'ok': {
      'body': 'Ellenőrzés után a vezeték nem jön ki a házából: A termékét ez a hiba nem érinti, teljes nyugalommal használhatja tovább.'
    }
  },
  'contact': {
    'name': 'Keresztnév',
    'firstName': 'Vezetéknév',
    'email': 'Emailcím',
    'country': 'Ország'
  }
} as const
